"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconRotate = exports.spinDirection = void 0;

var _animations = require("../../styles/animations");

var spinDirection = function spinDirection(spin) {
  switch (spin) {
    case 'clockwise':
      return _animations.spinClockwise;

    case 'counterclockwise':
      return _animations.spinCounterclockwise;

    default:
      return '';
  }
};

exports.spinDirection = spinDirection;

var iconRotate = function iconRotate(flip) {
  switch (flip) {
    case 'vertical':
      return 'scale(1, -1)';

    case 'horizontal':
      return 'scaleX(-1)';

    default:
      return '';
  }
};

exports.iconRotate = iconRotate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/ui_elements/icons/helpers.js
// module id = 535
// module chunks = 0 15 16 17 18